module.exports = __webpack_public_path__ + "static/icone-gerenciador-entregas-9351134defa1d062a9c75f73052229d4.svg";